<footer class="page-footer footer-style-6 ">
  <div class="holder ">
    <div class="footer-shop-info">
      <div class="container">
        <div class="text-icn-blocks-bg-row">
          <div class="text-icn-block-footer">
            <div class="icn">
              <i class="icon-trolley"></i>
            </div>
            <div class="text">
              <h4>Extra fast delivery</h4>
              <p>Your order will be delivered 3-5 business days after all of your items are available</p>
            </div>
          </div>
          <div class="text-icn-block-footer">
            <div class="icn">
              <i class="icon-currency"></i>
            </div>
            <div class="text">
              <h4>Best price</h4>
              <p>We'll match the product prices of key online and local competitors for immediately</p>
            </div>
          </div>
          <div class="text-icn-block-footer">
            <div class="icn">
              <i class="icon-diplom"></i>
            </div>
            <div class="text">
              <h4>Guarantee</h4>
              <p>If the item you want is available, we can process a return and place a new order</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-top">
    <div class="container">
      <div class="row mt-0">
        <div class="col-lg col-xl last-mobile col-no-collapsed">
          <div class="footer-block">
            <div class="footer-logo">
              <a [routerLink]="[]"><img class="" src="./assets/images/logo.png" data-srcset="./assets/images/logo.png" alt="Logo" srcset="./assets/images/logo.png 1x, ./assets/images/logo.png2x" type="image/webp"></a>
            </div>
            <div class="collapsed-content">
              <ul>
                <li>E-mail: <a [routerLink]="[]">contact@artourafrica.com</a></li>
                <li>Hours: 10:00 - 18:00, Mon - Fri</li>
              </ul>
            </div>
            <ul class="social-list">
              <li>
                <a [routerLink]="[]" class="icon icon-facebook"></a>
              </li>
              <li>
                <a [routerLink]="[]" class="icon icon-twitter"></a>
              </li>
              <li>
                <a [routerLink]="[]" class="icon icon-google"></a>
              </li>
              <li>
                <a [routerLink]="[]" class="icon icon-vimeo"></a>
              </li>
              <li>
                <a [routerLink]="[]" class="icon icon-youtube"></a>
              </li>
              <li>
                <a [routerLink]="[]" class="icon icon-pinterest"></a>
              </li>
            </ul>
            <div class="d-lg-none mt-3">
              <div class="box-coupon">
                <div class="box-coupon-icon"><i class="icon-scissors"></i></div>
                <div class="box-coupon-text"><span class="custom-color">AFRIC</span> ART</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg col-xl">
          <div  #collapsible1  class="footer-block collapsed-mobile ">
            <div class="title">
              <h4>Sell</h4>
              <span class="toggle-arrow" (click)="expand(collapsible1)"><span></span><span></span></span>
            </div>
            <div class="collapsed-content collapsable-content">
              <ul>
                <li><a [routerLink]="['/register']">Registration</a></li>
                <li><a [routerLink]="[]">How to sell</a></li>
              </ul>
            </div>

          </div>
          <div  #collapsible2 class="footer-block collapsed-mobile" >
            <div class="title">
              <h4>Buy</h4>
              <span class="toggle-arrow"(click)="expand(collapsible2)"><span></span><span></span></span>
            </div>
            <div class="collapsed-content collapsable-content">
              <ul>
                <li><a [routerLink]="['/howtobuy']">How to buy</a></li>
              </ul>
            </div>

          </div>

        </div>
        <div class="col-lg col-xl">
          <div  #collapsible3 class="footer-block collapsed-mobile">
            <div class="title">
              <h4>Help / Contact</h4>
              <span class="toggle-arrow" (click)="expand(collapsible3)"><span></span><span></span></span>
            </div>
            <div class="collapsed-content">
              <ul>
                <li><a [routerLink]="[]">Resolution Center</a></li>
                <li><a [routerLink]="[]">Seller Center</a></li>
                <li><a [routerLink]="['/contact']">Contact Us</a></li>

              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg col-xl">
          <div #collapsible4 class="footer-block collapsed-mobile">
            <div class="title">
              <h4>Safe payments</h4>
              <span class="toggle-arrow" (click)="expand(collapsible4)"><span></span><span></span></span>
            </div>
            <div class="collapsed-content">
            <img src="../../../../assets/images/paypal-payment.png">
            <br>
            <div class="d-none d-lg-block">
              <div class="box-coupon">
                <div class="box-coupon-icon"><i class="icon-scissors"></i></div>
                <div class="box-coupon-text"><span class="custom-color">AFRIC</span> ART</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom footer-bottom--bg">
    <div class="container">
      <div class="footer-copyright text-center">
        <a [routerLink]="[]">AfricArt</a> ©2020 copyright
      </div>
    </div>
  </div>
</footer>

